import { connect } from 'react-redux'
import compose from 'lodash/flowRight'

import { RigipsStore } from 'redux/redux'
import { withRouter } from 'react-router-dom'
import withProjectDataQuery from './projectDataQuery'
import withProjectDataMutation from './projectDataMutation'

import ProjectSettingsPage from './projectSettingsPage'

const mapStateToProps = (state: RigipsStore) => {
  const { auth } = state
  const { authenticated } = auth

  return { authenticated }
}

export default compose(
  connect(mapStateToProps),
  withProjectDataQuery,
  withProjectDataMutation,
  withRouter,
)(ProjectSettingsPage)
